import { environment } from "../environments/environments.demo";

export const baseUrlPPLR = environment.baseURL

export const NOMIVAC_VACCINATION = (params) => `${baseUrlPPLR}/aplicacionesVacunasCiudadano?id_tipo_doc=${params.id_tipo_doc}&nro_doc=${params.nro_doc}&sexo=${params.sexo}`;